import { Inject, Injectable } from '@angular/core';

import { gateway, legacy_pb } from 'libs/generated-grpc-web';
import { v4 as uuidv4 } from 'uuid';

import { AppConfigService } from '@app/src/app/minimal/services/AppConfig';
import { AuthService } from '@app/src/app/minimal/services/Auth';

import { AppRuntime, AppRuntimeInterface } from '@shared/services/app-runtime';

import { SsoInterface } from './sso.types';
import { getStoredState, setStoredState, clearStoredState } from './sso.utils';

export const STORAGE_KEY = 'rosterstream_sso';

@Injectable({ providedIn: 'root' })
export class RosterstreamService implements SsoInterface {
  constructor(
    @Inject(AppRuntimeInterface) private _runtime: AppRuntime,
    private _appConfig: AppConfigService,
    private _loginManager: gateway.login_ng_grpc_pb.LoginManager,
    private _authService: AuthService,
  ) {}

  public validateState(returnedState: string): boolean {
    const data = getStoredState(STORAGE_KEY);
    if (!data?.expiry || !data?.state) {
      return false;
    }

    const isExpired = Date.now() > data.expiry;
    const isValid = data.state === returnedState;

    // this is for 1 time use so we clear it after validation
    clearStoredState(STORAGE_KEY);
    return isValid && !isExpired;
  }

  public async initiateLogin(provider: string) {
    const platform = window.MINGA_APP_PLATFORM;

    const state = uuidv4();
    setStoredState(STORAGE_KEY, state, Date.now() + 5 * 60 * 1000);

    const { callbacks, host, clientId } = this._appConfig.getValue('rosterStreamSSO');
    const callbackUrl = callbacks[platform];

    if (!callbackUrl) {
      throw new Error(`No callback URL configured for platform: ${platform}`);
    }

    // Build the OAuth URL with state parameter included in callback URL
    const callbackWithState = `${callbackUrl}?state=${state}&provider=${provider}`;
    const url = `${host}/login/${provider}/${clientId}?callback=${encodeURIComponent(callbackWithState)}`;

    if (this._runtime.isNativeApp()) {
      (<any>window).cordova.InAppBrowser.open(url, '_system');
    } else {
      window.location.href = url;
    }
  }

  public async login(code: string) {
    const rosterstreamRequest = new gateway.login_pb.RosterstreamLoginRequest();
    rosterstreamRequest.setCode(code);

    const response = await this._loginManager.rosterstreamLogin(rosterstreamRequest);

    return await this._authService.handleAuthResponse(response);
  }

  public onSsoCallbackReturn() {
    console.log('on SSO Callback Return');
  }
}
